var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1719107501416,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 19583,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 972.8C260.266667 972.8 51.2 763.733333 51.2 512S260.266667 51.2 512 51.2 972.8 260.266667 972.8 512 763.733333 972.8 512 972.8z m0-853.333333c-217.6 0-392.533333 174.933333-392.533333 392.533333s174.933333 392.533333 392.533333 392.533333 392.533333-174.933333 392.533333-392.533333-174.933333-392.533333-392.533333-392.533333z",
    "p-id": 19584,
    fill: "#333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M537.6 716.8H405.333333c-17.066667 0-34.133333-12.8-34.133333-34.133333V341.333333c0-17.066667 12.8-34.133333 34.133333-34.133333h132.266667c72.533333 0 115.2 55.466667 115.2 115.2 0 29.866667-8.533333 55.466667-29.866667 76.8l-4.266666 4.266667c21.333333 21.333333 34.133333 55.466667 34.133333 89.6 0 29.866667-8.533333 59.733333-25.6 81.066666-25.6 25.6-55.466667 42.666667-89.6 42.666667z m-102.4-68.266667h98.133333c17.066667 0 25.6-4.266667 34.133334-17.066666 8.533333-8.533333 12.8-25.6 12.8-42.666667 0-4.266667 0-55.466667-51.2-55.466667h-98.133334l4.266667 115.2z m0-174.933333h98.133333c34.133333 0 51.2-25.6 51.2-51.2s-12.8-51.2-51.2-51.2h-98.133333v102.4z",
    "p-id": 19585,
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgB);
export default __webpack_public_path__ + "static/media/b.547e27858021dbd4459fae5ce608f6c6.svg";
export { ForwardRef as ReactComponent };